export default __webpack_public_path__ + "static/home_bodegon-755621bbbbfa568bd41f764a05d04ee8.png";